import { IconButton, MenuItem, Select, Typography, CircularProgress } from "@mui/material";
import { ChevronLeft, ChevronRight } from "@mui/icons-material";

const PaginationShell = ({ nextFunction, prevFunction, currentPage, totalItems, totalPage, initialItem, finalItem, loadingState}) => {
	return (
		<div style={{ display: "flex", alignItems: "center" }}>
			<Select size="small" aria-label="Per" sx={{ height: "30px" }} value={20} disabled>
				<MenuItem key={20} value={20}>
					<Typography
						sx={{
							fontFamily: "Roboto",
							fontSize: "13px",
							fontWeight: "bold",
							textAlign: "center",
							color: "#30617C",
						}}
					>
						20
					</Typography>
				</MenuItem>
			</Select>
			<div
				style={{
					width: "200px",
					display: "flex",
					justifyContent: "space-between",
					alignItems: "center",
				}}
			>
				<IconButton
					onClick={(e) => {
						e.preventDefault();
						if (currentPage > 0) {
							prevFunction();
						}
					}}
					disabled={currentPage === 0}
				>
					<ChevronLeft sx={{ color: "#30617C" }} />
				</IconButton>
				{
					!loadingState && totalItems > 0 && /* initialItem && finalItem && */
						<Typography id="text-paginator" style={{ fontSize: "13px" }}>
							{`${initialItem} al ${finalItem} de ${totalItems}`}
						</Typography>
				}
				{
					!loadingState && totalItems === 0 &&
						<Typography id="text-paginator" style={{ fontSize: "13px" }}>
							{"Sin resultados"}
						</Typography>
				}
				{
					loadingState &&
						<Typography id="text-paginator" style={{ fontSize: "13px" }}>
							<CircularProgress color="inherit" size={20} />
						</Typography>
				}
				<IconButton
					onClick={(e) => {
						e.preventDefault();
						nextFunction();
					}}
					disabled={currentPage >= totalPage - 1}
				>
					<ChevronRight sx={{ color: "#30617C" }} />
				</IconButton>
			</div>
		</div>
	);
};

export default PaginationShell;